import SectionStructure from '../../../../components/Section/SectionStructure';
import Grid from '@mui/material/Grid';
import MicrobiomeText from './MicrobiomeText'
import CvdButtonGroup from './CvdButtonGroup'

import GETMICRO from '../../../MainWelcome/CVD/CVD_Microbiome/MB_Status/GETMICRO'
import GutHeartAxisCard from '../../../MainWelcome/CVD/CVD_Microbiome/MB_GutHeartAxis/GutHeartAxisCard';
import SyndromeCard from "../../../MainWelcome/CVD/CVD_Microbiome/Syndrome/SyndromeCard";
import InsulinCard from "../../../MainWelcome/CVD/CVD_Microbiome/Insulin/InsulinCard"
import MicroCard2 from '../../../MainWelcome/CVD/CVD_Microbiome/MB_Status/MicroCard2';
import MicroCard3 from '../../../MainWelcome/CVD/CVD_Microbiome/MB_Status/MicroCard3';


export default function SectionMicrobiome() {

    
    return (

        <SectionStructure
    
        sectiontext=    { <MicrobiomeText /> }
        sectiondiagroup=    { <CvdButtonGroup />} 

        sectioncards=  {<>

            <Grid container>
                    
                    <Grid > <GETMICRO />      </Grid>
                    <Grid >  <MicroCard2 />   </Grid>
                    <Grid>  <MicroCard3 />    </Grid>
                    <Grid>  <GutHeartAxisCard />  </Grid>
                    <Grid>  <SyndromeCard />  </Grid>
                    <Grid> <InsulinCard />    </Grid>
                    
            </Grid>
        </>}
    />
    )}
